import React from "react";
import CaretIcon from "../Shared/CaretIcon";
export interface Props {
  link?: string;
  linkText?: string;
  description?: string;
}
const LinkTile = ({
  linkText,
  link,
  description
}: Props) => {
  return <div className="text-center pt-2 pb-3 min-h-16 flex flex-col justify-center items-center" data-sentry-component="LinkTile" data-sentry-source-file="LinkTile.tsx">
      <p className="leading-none text-lg text-gray-800 font-regular mb-2 h-8 flex justify-center items-center">
        {description}
      </p>
      <a href={link} className="text-sm font-bold text-green-500 no-underline flex justify-center items-center leading-none hover:underline transition-all duration-75 ease-in-out">
        {linkText}
        <CaretIcon data-sentry-element="CaretIcon" data-sentry-source-file="LinkTile.tsx" />
      </a>
    </div>;
};
export default LinkTile;